import Classes from "./CountForm.module.css"

export const ExtendersCountForm = () => {


  return <div className={Classes.main_div}>This is the extenders count form</div>
}

